function convertActionTypeToName(actionType: string) {
  return actionType.toLowerCase().replace(/_(\w)/g, (v) => v[1].toUpperCase());
}

export default function createReducer(state: any, action: any, handlers: any) {
  const key = convertActionTypeToName(action.type);
  const handler = handlers[key];
  if (handler) {
    handler(state, action);
  }
}
